import { render } from "./WorkshopChecklist.vue?vue&type=template&id=2616d9ae&scoped=true"
import script from "./WorkshopChecklist.vue?vue&type=script&lang=js"
export * from "./WorkshopChecklist.vue?vue&type=script&lang=js"

import "./WorkshopChecklist.vue?vue&type=style&index=0&id=2616d9ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2616d9ae"]])

export default __exports__